"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.distributeDiscount = void 0;
var get_1 = __importDefault(require("lodash/get"));
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var constants_1 = require("./constants");
var util_1 = require("./util");
var getBundlePromoValue_1 = require("./getBundlePromoValue");
var mealDeal_1 = require("./mealDeal");
var distributeDiscountAmount_1 = require("./distributeDiscountAmount");
// The returned bundles will always have a fixed promotion amount
// after the given promotion was calculated and distributed.
// this so we do not refactor the calcualte VAT section of order service
// in the future, we should just calculate discountAmount on the bundle here
function distributeDiscount(basketBundles, promotion) {
    // TODO: Refactor: Let the caller handle the promotion selection
    // to make it possible to support other types promotion application
    // such as multiple basket discounts
    var promo = promotion ||
        (0, cloneDeep_1.default)((0, get_1.default)(basketBundles.find(util_1.Bundle.hasPromo), "promotion"));
    if (!promo)
        return basketBundles;
    var bundlesWithSort = basketBundles.map(function (bundle, index) {
        var _a;
        return (__assign(__assign({}, bundle), (_a = {}, _a[constants_1.SORT_KEY] = index, _a)));
    });
    var groupMealDeals = [constants_1.PromoAppliesTo.AssocBundles, constants_1.PromoAppliesTo.AssocMostExpensive].includes(promo.appliesTo);
    var discountedMealDealMap = mealDeal_1.MealDeal.mapFromBasket(bundlesWithSort);
    var isDiscountedWithoutMealDeal = function (bundle) {
        return util_1.Bundle.hasPromo(bundle) && !util_1.Bundle.hasDiscountedMealDeal(bundle);
    };
    var discountedBundles = groupMealDeals
        ? bundlesWithSort.filter(isDiscountedWithoutMealDeal)
        : bundlesWithSort.filter(function (bundle) { return util_1.Bundle.hasPromo(bundle); });
    var discountedBundlesWithMealDeal = groupMealDeals
        ? mealDeal_1.MealDeal.discountedBundles(bundlesWithSort)
        : [];
    var eligibleBundlesPrice = util_1.Bundle.priceTotal(discountedBundles);
    var eligibleMealDealsPrice = util_1.Bundle.priceTotal(discountedBundlesWithMealDeal);
    var priceOfAllDiscountedItems = (0, util_1.currency)(0)
        .add(eligibleBundlesPrice)
        .add(eligibleMealDealsPrice).value;
    var isBundleLevel = !util_1.PromotionService.isOrderLevel(promo);
    if (isBundleLevel && util_1.PromotionService.isFixed(promo)) {
        var mealDealBundlesDiscount = mealDeal_1.MealDeal.discountedTotal(discountedMealDealMap, promo);
        var result = __spreadArray(__spreadArray([], discountedBundles.map(function (bundle) { return (__assign(__assign({}, bundle), { discount: (0, getBundlePromoValue_1.getBundlePromoValue)(bundle.finalPrice, promo) })); }), true), mealDeal_1.MealDeal.distributeDiscount(discountedMealDealMap, mealDealBundlesDiscount, promo), true);
        return util_1.Bundle.mergeAndSort(result, bundlesWithSort);
    }
    var totalBasketPromo = isBundleLevel
        ? __assign(__assign({}, promo), { value: (0, getBundlePromoValue_1.getBundlePromoValue)(priceOfAllDiscountedItems, promo), type: 'fixed' }) : promo;
    var totalAmountToDiscount = (0, getBundlePromoValue_1.getBundlePromoValue)(priceOfAllDiscountedItems, totalBasketPromo);
    var proportionalBundlesDiscount = !util_1.PromotionService.isFixed(promo)
        ? util_1.MathUtil.proportion(totalAmountToDiscount, priceOfAllDiscountedItems, eligibleBundlesPrice)
        : promo.value;
    var proportionalDealBundlesDiscount = proportionalBundlesDiscount > 0
        ? Math.max((0, util_1.currency)(totalAmountToDiscount).subtract(proportionalBundlesDiscount).value, 0)
        : util_1.MathUtil.proportion(totalAmountToDiscount, priceOfAllDiscountedItems, eligibleMealDealsPrice);
    // proportional discount needed when max discount amount is reached
    var resultBundles = __spreadArray(__spreadArray([], (0, distributeDiscountAmount_1.distributeDiscountAmount)(discountedBundles, proportionalBundlesDiscount, eligibleBundlesPrice, promo), true), mealDeal_1.MealDeal.distributeDiscount(discountedMealDealMap, proportionalDealBundlesDiscount, promo), true);
    return util_1.Bundle.mergeAndSort(resultBundles, bundlesWithSort);
}
exports.distributeDiscount = distributeDiscount;
